import { AfterContentInit, Component, NO_ERRORS_SCHEMA, OnDestroy, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DrawerItem, DrawerSelectEvent, LayoutModule } from '@progress/kendo-angular-layout';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import {
  SVGIcon,
  alignJustifyIcon,
  menuIcon,
  parametersUnknownIcon,
  windowIcon,
} from "@progress/kendo-svg-icons";

const wIcon: SVGIcon = windowIcon;
const alignIcon: SVGIcon = alignJustifyIcon;
const parametersIcon: SVGIcon = parametersUnknownIcon;

export const bottomNavigationRoutes = [
  {
    path: "",
    component: BreadCrumbComponent,
    text: "BreadCrumb",
    svgIcon: parametersIcon,
    selected: true,
  },
  {
    path: "appbar",
    component: AppBarComponent,
    text: "AppBar",
    svgIcon: wIcon,
    selected: false,
  },
  {
    path: "actionsheet",
    component: ActionSheetComponent,
    text: "ActionSheet",
    svgIcon: alignIcon,
    selected: false,
  },
];

import { IndicatorsModule } from "@progress/kendo-angular-indicators";
import { BreadCrumbComponent } from '../bread-crumb/bread-crumb.component';
import { AppBarComponent } from '../app-bar/app-bar.component';
import { ActionSheetComponent } from '../action-sheet/action-sheet.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { IconsModule } from '@progress/kendo-angular-icons';
import { LoggerService } from '../../shared/logger.service';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ContentComponent } from '../content/content.component';
import { CasiStoryEstimate, CasiStoryPriority,
  CasiStoryStatus, CasiStoryType, CasiUserStory, IProject, Project,
  ProjectType, StoryPriority, StoryState, StoryType, User as UserModel } from '../../models/models.lib';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LabelModule } from '@progress/kendo-angular-label';
import { SettingsService } from '../../settings/settings.service';
import { TileLayoutComponent } from '../tile-layout/tile-layout.component';
import { Test1Component } from '../tiles/test1/test1.component';
import { DrawItemNames, FormModes } from '../../common/constants.lib';
import { TooltipDirective, TooltipsModule } from '@progress/kendo-angular-tooltip';
import { MyWorkComponent } from '../tiles/my-work/my-work.component';
import { tilesCollection } from '../trackerUtils';
import { AppStateService } from '../../shared/app-state.service';
import { LoadingIndicatorService } from '../../shared/loading-indicator.service';
import { TileItem } from '../../common/obj.lib';
import { UserStoryService } from '../user-story.service';
import { setTitle } from '../../common/utils.lib';
import { CasiEventService } from '../casi-event.service';
import { WindowModule } from '@progress/kendo-angular-dialog';
import { UserStoryModalComponent } from '../user-story-modal/user-story-modal.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'casi-tracker',
  standalone: true,
  imports: [
    CommonModule,
    LayoutModule,
    ButtonsModule,
    IndicatorsModule,
    RouterModule,
    FontAwesomeModule,
    IconsModule,
    NavigationModule,
    ContentComponent,
    DropDownsModule,
    ReactiveFormsModule,
    LabelModule,
    TileLayoutComponent,
    Test1Component,
    TooltipsModule,
    MyWorkComponent,
    WindowModule,
    UserStoryModalComponent
  ],
  schemas: [NO_ERRORS_SCHEMA],
  // encapsulation: ViewEncapsulation.None,
  templateUrl: './tracker.component.html',
  styleUrl: './tracker.component.scss'
})
export class TrackerComponent implements OnInit, OnDestroy, AfterContentInit {
  @ViewChild(TooltipDirective) public tooltipDir!: TooltipDirective;
  @ViewChild('drawer') public drawer: any;
  @ViewChild("appendTo", { read: ViewContainerRef }) appendTo: ViewContainerRef | undefined;

  public selected = "Inbox";
  public menuSvg: SVGIcon = menuIcon;
  public projects: Project[] = [];
  public users: UserModel[] = [];
  public storyStatus: CasiStoryStatus[] = [];
  public storyTypes: CasiStoryType[] = [];
  public storyPriorities: CasiStoryPriority[] = [];
  public storyEstimates: CasiStoryEstimate[] = [];

  public currentProject: ProjectType | undefined = undefined;

  public items: Array<DrawerItem> = [
    {
      text: DrawItemNames.MyWork, svgIcon: {
        name: 'mywork',
        content: '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z"></path></svg>',
        viewBox: '0 0 24 24'
      }
    },
    // { separator: true },
    {
      text: DrawItemNames.CurrentBacklog, svgIcon: {
        name: 'currentbacklog',
        content: '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M4,14 L6,14 C6.55,14 7,13.55 7,13 L7,11 C7,10.45 6.55,10 6,10 L4,10 C3.45,10 3,10.45 3,11 L3,13 C3,13.55 3.45,14 4,14 Z M4,19 L6,19 C6.55,19 7,18.55 7,18 L7,16 C7,15.45 6.55,15 6,15 L4,15 C3.45,15 3,15.45 3,16 L3,18 C3,18.55 3.45,19 4,19 Z M4,9 L6,9 C6.55,9 7,8.55 7,8 L7,6 C7,5.45 6.55,5 6,5 L4,5 C3.45,5 3,5.45 3,6 L3,8 C3,8.55 3.45,9 4,9 Z M8.83333333,14 L17.1666667,14 C17.625,14 18,13.55 18,13 L18,11 C18,10.45 17.625,10 17.1666667,10 L8.83333333,10 C8.375,10 8,10.45 8,11 L8,13 C8,13.55 8.375,14 8.83333333,14 Z M9,19 L19,19 C19.55,19 20,18.55 20,18 L20,16 C20,15.45 19.55,15 19,15 L9,15 C8.45,15 8,15.45 8,16 L8,18 C8,18.55 8.45,19 9,19 Z M8,6 L8,8 C8,8.55 8.45,9 9,9 L19,9 C19.55,9 20,8.55 20,8 L20,6 C20,5.45 19.55,5 19,5 L9,5 C8.45,5 8,5.45 8,6 Z"></path></svg>',
        viewBox: '0 0 24 24'
      }
    },
    {
      text: DrawItemNames.IceBox, svgIcon: {
        name: 'snowflake',
        content: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M224 0c13.3 0 24 10.7 24 24l0 46.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57 0 76.5 66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6l0 76.5 57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23 0 46.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-46.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-76.5-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4l0-76.5L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L200 24c0-13.3 10.7-24 24-24z"/></svg>',
        viewBox: '0 0 448 512'
      }
    },
    // { separator: true },
    {
      text: DrawItemNames.Done, svgIcon: {
        name: 'snowflake',
        content: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc. --><defs><style>.fa-secondary{opacity:.4}</style></defs><path class="fa-secondary" d=""/><path class="fa-primary" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>',
        viewBox: '0 0 448 512'
      }
    },
    {
      text: DrawItemNames.Blocked, svgIcon: {
        name: 'blocked',
        content: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc. --><defs><style>.fa-secondary{opacity:.4}</style></defs><path class="fa-secondary" d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/><path class="fa-primary" d="M280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184zM256 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>',
        viewBox: '0 0 512 512'
      }
    },
    // { separator: true },
    {
      text: DrawItemNames.Epics, svgIcon: {
        name: 'epics',
        content: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc. --><defs><style>.fa-secondary{opacity:.4}</style></defs><path class="fa-secondary" d="M256.7 0L256 0c-4.6 0-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.1 24 2.6 52.9 8.7 84H256V0h.7zM488 224H256.7V509.1c9 0 18.1-2 26.4-6C413.7 440.7 468.8 321.3 488 224z"/><path class="fa-primary" d="M256.4 0l.3 0c4.6 0 9.2 1 13.4 2.9L458.4 82.8c22 9.3 38.4 31 38.3 57.2c-.1 24-2.6 52.9-8.7 84H256.7V0H256l0 0h-.7l.7 0 .3 0zM229.6 503.2C99 440.7 44 321.3 24.7 224H256V509.1c-9 0-18.1-2-26.4-6z"/></svg>',
        viewBox: '0 0 512 512'
      }
    },
    {
      text: DrawItemNames.Labels, svgIcon: {
        name: 'labels',
        content: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc. --><defs><style>.fa-secondary{opacity:.4}</style></defs><path class="fa-secondary" d="M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/><path class="fa-primary" d=""/></svg>',
        viewBox: '0 0 448 512'
      }
    },
    {
      text: DrawItemNames.ProjectHistory, svgIcon: {
        name: 'projecthistory',
        content: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc. --><defs><style>.fa-secondary{opacity:.4}</style></defs><path class="fa-secondary" d="M120.2 120.2C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8z"/><path class="fa-primary" d="M256 128c13.3 0 24 10.7 24 24v94.1l65 65c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72c-4.5-4.5-7-10.6-7-17V152c0-13.3 10.7-24 24-24z"/></svg>',
        viewBox: '0 0 512 512'
      }
    }
  ];

  private _userStories = new BehaviorSubject<CasiUserStory[]>([]);
  get $userStories() {
    return this._userStories.asObservable();
  }
  get userStories() {
    return this._userStories.getValue();
  }
  set userStories(val: CasiUserStory[]) {
    this._userStories.next(val);
  }

  private _showTitle = new BehaviorSubject<string>('');
  get showTitle() {
    return this._showTitle.getValue();
  }
  set showTitle(val: string) {
    this._showTitle.next(val);
  }

  private baseTileCollection: TileItem[] = this.appStateService.currentTiles;

  public selectedUserStoryId: string | null = null;

  public tiles: TileItem[] = [];
  public editWinOpen: boolean = false;
  public formMode: FormModes = FormModes.NOTSET;

  public defaultProjectItem: { text: string; id: number | null } = {
    text: "Select ...",
    id: null
  }

  public drawExpanded: boolean = false;

  title = 'Socket.IO + Angular Chat';
  public message = '';
  public messages: string[] = [];

  private _subs: Subscription[] = [];

  constructor(
    private logger: LoggerService,
    public faIcons: FaIconLibrary,
    private route: ActivatedRoute,
    // private settingService: SettingsService,
    private appStateService: AppStateService,
    private loadingIndictorService: LoadingIndicatorService,
    private userStoryService: UserStoryService,
    private casiEventService: CasiEventService,
  ) {
    faIcons.addIcons(...all);
    // this._subs.push(this.socketService.getMessages().subscribe((msg) => {
    //   this.messages.push(msg);
    // }));
  }

  //#region Ng Handlers

  ngOnInit(): void {
    this.logger.debug('ngOnInit...', this.appStateService.hasTiles);
    this.loadingIndictorService.loadingOff();
    this.logger.debug('ngOnInit...tilesCollection', tilesCollection);
    if (!this.appStateService.hasTiles) {
      this.appStateService.currentTiles = tilesCollection;
    } else {
      // this.tiles = this.appStateService.currentTiles;
    }

    this._subs.push(this.route.data.subscribe(({
      projects,
      users,
      storyStatus,
      storyTypes,
      storyPriorities,
      storyEstimates
    }) => {
      this.projects = projects;
      this.users = users;
      this.storyStatus = storyStatus;
      this.storyTypes = storyTypes;
      this.storyPriorities = storyPriorities;
      this.storyEstimates = storyEstimates;
      this.logger.debug(`ngOnInit:projects: `, this.projects);
      this.logger.debug(`ngOnInit:users: `, this.users);
      this.logger.debug(`ngOnInit:storyStatus: `, this.storyStatus);
      this.logger.debug(`ngOnInit:storyEstimates: `, this.storyEstimates);
      this.logger.debug(`ngOnInit:storyTypes: `, this.storyTypes);
      // this.currentProject = this.appStateService.currentProject;
      // if (this.currentProject)
      //   this.userStoryService.query((this.currentProject as Project).id);
      // this.fetchData();
      // this.startPolling()
    }));

    this._subs.push(this.userStoryService.subscribe(us => {
      if (us) {
        this.userStories = us;
      } else {
        this.userStories = [];
      }
    }));
    this._subs.push(this.casiEventService.casiEvent$.subscribe((e) => {
      this.logger.debug(`ngOnInit:casiEvent: `, e);
      if (e.target) {
        this.logger.debug(`ngOnInit:casiEvent: componentName:`, e.target);
        this.logger.debug(`ngOnInit:casiEvent: componentName:`, e.target === this.constructor.name);
        this.onAddClicked();
        //  if (e.target === this.constructor.name) {
        //           this.onAddClicked();
        //         }
      }
    }));

    this.route.queryParams.subscribe((params) => {
      this.logger.debug('got query params', params);
      if (params['projectId'] && params['storyId']) {
        this.selectedUserStoryId = params['storyId'];
        this.currentProject = this.projects.find((value, index, array) => {
          this.logger.debug('val', value);
          return value.id == parseInt(params['projectId']);
        });
        this.logger.debug('PROJECT?', this.currentProject);
        if (!this.currentProject)
          this.currentProject = this.appStateService.currentProject;
        if (this.currentProject)
          this.userStoryService.query((this.currentProject as Project).id);
      }
      else {
        this.currentProject = this.appStateService.currentProject;
        if (this.currentProject)
          this.userStoryService.query((this.currentProject as Project).id);
      }
    });

  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  ngAfterContentInit(): void {
    this.logger.debug('ngAfterContentInit...');
    this.baseTileCollection = this.appStateService.currentTiles;
    this.logger.debug('ngAfterContentInit...baseTileCollection', this.baseTileCollection);

    this.baseTileCollection.forEach((t, indx) => {
      t.col = indx;
      this.tiles.push(t);
    })
    this.logger.debug('ngAfterContentInit...tiles', this.tiles);
  }

  //#endregion

  public close(): void {
    this.logger.debug('close...');
    this.editWinOpen = false;
  }

  public onAddClicked(): void {
    this.logger.debug("onAddClicked...");
    // this.currentItem = <IUserStory>{ title: 'New Title' };
    // this.formMode = FormModes.NEW;
    // this.logger.debug("onAddClicked:currentItem ", this.currentItem);
    this.showTitle = setTitle(this.formMode, 'User Story');
    this.editWinOpen = true;
    // this._windowRef = this.windowService.open({
    //   // titleBarContent: this.windowTitleBar,
    //   appendTo: this.appendTo,
    //   title: setTitle(this.formMode, 'User Story'),
    //   content: 'My Content!',
    //   width: 1000,
    //   minWidth: 320,
    //   height: 300
    // });
    // this._windowRef.result.subscribe(results => {
    //   this.logger.debug('showAddWindow:results: ', results);
    //   if (results instanceof WindowCloseResult) {
    //     this.closeWindowRef();
    //   }
    // });

    // this._windowRef.content.instance.closeForm.subscribe(() => {
    //   this.logger.debug('showAddWindow:closeForm');
    //   this.closeWindowRef();
    // });

  }

  toggleDraw() {
    this.drawExpanded = !this.drawExpanded;
  }

  public onSelect(ev: DrawerSelectEvent): void {
    this.logger.debug(`onSelect:ev:`, ev);
    this.selected = ev.item.text;
    // this.drawExpanded = false;
    this.logger.debug(`onSelect:text:`, ev.item.text);
    let found = tilesCollection.find(t => t.ref === ev.item.text);
    let alreadyInTiles = this.tiles.find(t => t.ref === ev.item.text);
    this.logger.debug(`onSelect:found`, found);
    if (found && !alreadyInTiles) {
      found.col = this.tiles.length;
      this.tiles.push(found);
      this.saveTiles();
    }
  }

  public projectValueChange(value: any): void {
    this.logger.debug(`projectValueChange...`, value);
    if (value && value.id) {
      this.currentProject = value;
      this.appStateService.currentProject = value;
      this.userStoryService.query((this.currentProject as Project).id);

    } else {
      this.currentProject = undefined;
      this.appStateService.currentProject = undefined;
      this.userStories = [];
    }
    // this.fetchData();
  }

  public handleTileClose(tile: TileItem) {
    this.logger.debug(`handleTileClose: `, tile);
    this.tiles = this.tiles.filter((t) => t.ref !== tile.ref);
    this.logger.debug(`handleTileClose: tiles`, this.tiles);
    this.saveTiles();
  }

  public showTooltip(e: MouseEvent) {
    // this.logger.debug(`showTooltip: `, e.type);
    const element = e.target as HTMLElement;
    // this.logger.debug(`showTooltip: element`, element.nodeName, this.drawer.expanded);
    if ((element.nodeName === 'LI' || element.nodeName === 'KENDO-SVGICON') &&
      !element.className.includes('k-drawer-separator') &&
      !this.drawer.expanded) {
      if (this.tooltipDir)
        this.tooltipDir.toggle(element);
    } else {
      if (this.tooltipDir)
        this.tooltipDir.hide();
    }
  }

  public onUserStorySave(): void {
    this.logger.debug('onUserStorySave...');
    // this.handleAccessRightClose();
  }

  public closeUserStory(): void {
    this.logger.debug('closeUserStory...');
    this.editWinOpen = false;
  }

  private saveTiles() {
    this.logger.debug(`saveTiles...`, this.tiles);
    this.appStateService.currentTiles = this.tiles;

  }
}

